import React from "react";
import { I18n } from "@aws-amplify/core";
import { size } from "lodash";

import Grid from "@material-ui/core/Grid";

import TakePicture from "./TakePicture";

import colors from "../../assets/style/colors";

const AddPicture = (props) => {
  const { id, pictures = [], setPictures } = props;

  const addPicture = (p) => {
    setPictures([...pictures, p]);
  };

  const handleChange = (e) => {
    let componentId = e.target.id;
    let files = e.target.files;
    let newImages = [];
    for (let i = 0; i < files.length; i++) {
      // Check file extension
      if (/\.(jpe?g|JPE?G|png|PNG)$/i.test(files[i].name)) {
        let fileReader = new FileReader();
        fileReader.addEventListener(
          "load",
          function () {
            if (id === componentId) {
              newImages.push(this.result);
              if (i === size(files) - 1) {
                setPictures([...pictures, ...newImages]);
              }
            }
          },
          false
        );
        fileReader.readAsDataURL(files[i]);
      }
    }
  };

  return (
    <Grid container style={{ maxWidth: "170px" }}>
      <Grid item className="flexCenter" style={{ margin: "0px 17px" }}>
        <TakePicture setPicture={addPicture} />
      </Grid>
      <Grid
        item
        className="flexCenter"
        style={{
          borderLeft: `1px solid ${colors.black23}`,
          height: "22px",
          paddingLeft: "17px",
          margin: "auto",
        }}
      >
        <label htmlFor={id}>
          <span
            style={{
              fontWeight: 500,
              color: colors.primary,
              cursor: "pointer",
            }}
          >
            {I18n.get("site_browse")}
          </span>
        </label>
        <input
          type="file"
          id={id}
          onChange={handleChange}
          style={{ display: "none" }}
          multiple="multiple"
        />
      </Grid>
    </Grid>
  );
};

export default AddPicture;
